import { area, length } from "@turf/turf";
import type { Feature } from "geojson";

import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import CropLandscapeIcon from "@mui/icons-material/CropLandscape";
import { Grid, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { useTranslation } from "common/locales";
import { booleanValid, useArea } from "common/utils";

interface FieldStatsProps {
  geom: Feature;
  direction: "column" | "row";
}

export default function FieldStats({ geom, direction }: FieldStatsProps) {
  const { t } = useTranslation();
  const { fromM2, label } = useArea();
  const geomIsValid = geom && booleanValid(geom);
  return (
    <Grid container direction={direction}>
      <Grid size={12}>
        <ListItem>
          <ListItemIcon>
            <AspectRatioIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              geomIsValid
                ? `${fromM2(area(geom)).toFixed(2)} ${label}`
                : t("fieldinput.na")
            }
            secondary={t("fieldinput.area.text")}
          />
        </ListItem>
      </Grid>
      <Grid size={12}>
        <ListItem>
          <ListItemIcon>
            <CropLandscapeIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              geomIsValid
                ? `${Math.round(length(geom, { units: "meters" }))} ${t(
                    "fieldview.perimeter.unit"
                  )}`
                : t("fieldinput.na")
            }
            secondary={t("fieldview.perimeter.text")}
          />
        </ListItem>
      </Grid>
    </Grid>
  );
}
